<script>
import LoginForm from '../components/LoginForm.vue'
import LangSwitcher from '../components/LangSwitcher.vue'
import messages from '@/mixins/messages'

export default {
    name: 'Login',
    mixins: [messages],
    components: { LoginForm, LangSwitcher },
    methods: {
        onLogin() {
            if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect)
            } else {
                this.$router.push({ name: 'reservations' })
            }
        },
    },
    mounted() {
        if (this.$route.query.errorCode === 'tokenExpired') {
            this.addMessage('danger', 'Your Token or Session has expired. Please try again.')
        }
        if (this.$route.query.token) {
            this.$store.commit('setToken', this.$route.query.token)
            var seg = window.location.pathname.split('/')[1]
            var localePrefix = ['fr', 'es', 'de'].includes(seg) ? ('/' + seg) : ''
            window.location.href = localePrefix + '/dashboard'
        }
    },
}
</script>

<template>
    <b-container class="login">
        <b-row>
            <b-col lg="6" offset-lg="3" xl="4" offset-xl="4" class="mt-5">
                <login-form @success="onLogin">
                    <template #header-action>
                        <small><lang-switcher dark /></small>
                    </template>
                    <messages v-model="messages" />
                </login-form>
            </b-col>
        </b-row>
    </b-container>
</template>
